import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Input } from 'reactstrap';
import {ArraySelect, InputAddressSelect, InputKeySelect} from "@pages/components/InputSelect";
import InputCustom from "@pages/components/InputCustom";
import * as constants from 'constants/index.js';
import DebounceInput from "@pages/components/DebounceInput";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
const allowedFields = [
    'postal_code',
    'address',
    'street',
    'previous_address',
    'land_line_number',
    'city',
    'time_at_address',
    'is_active',
    'building',
    'county_id',
];
export default function Address({
                                           initialCustomer,
                                           errors,
                                           address,
                                           counties,
                                           lookupAddresses,
                                           setSelectedAddress,
                                           getAddressByPostcode,
                                           onSave,
                                       }) {


    const [customer, setCustomer] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (initialCustomer) {
            const filtered = Object.fromEntries(
                allowedFields.map((key) => [key, initialCustomer[key] ?? ''])
            );
            setCustomer(filtered);
            setLoading(false)
        }
    }, [initialCustomer]);

    const getValue = (key) => customer?.[key] ?? '';

    const update = (updates) => {
        setCustomer((prev) => ({
            ...prev,
            ...updates,
        }));
    };
    const handleSave = () => {
        onSave(customer);
    };
    return (
        loading ? <LoaderContainer>
                <ClipLoader
                    css={override}
                    size={40}
                    color={`#7B61E4`}
                    loading={loading}
                />
            </LoaderContainer>
         :  <Card>
            <CardHeader>
                <h1 className="mb-0">Address details</h1>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md={4} sm={6}>
                        <DebounceInput
                            label="Postal Code"
                            defaultValue={getValue('postal_code')}
                            placeholder="Postal Code"
                            onChange={(e) => getAddressByPostcode(e.target.value)}
                        />
                        <InputCustom
                            newLabel={'Address'}
                            placeholder="Address"
                            type="text"
                            required
                            checkValid={false}
                            value={customer ? customer.address : ''}
                            onChange={(e) => update({'address': e.target.value})}
                            invalid={!!errors?.address}
                            errorMessage={'Address field is required.'}
                        />
                        <InputCustom
                            newLabel="Street"
                            placeholder="Street"
                            value={getValue('street')}
                            onChange={(e) => update({'street': e.target.value})}
                        />
                        <InputCustom
                            newLabel="Previous Address"
                            placeholder="Previous Address"
                            value={getValue('previous_address')}
                            onChange={(e) => update({'previous_address': e.target.value})}
                            invalid={!!errors?.previous_address}
                            errorMessage={errors?.previous_address}
                        />
                    </Col>

                    <Col md={4} sm={6}>
                        <InputAddressSelect
                            value={address?.Udprn}
                            options={lookupAddresses}
                            onChange={(e) => {
                                const selectedAddress = lookupAddresses.find(
                                    (item) => item.Udprn?.toString() === e.target.value?.toString()
                                );
                                setSelectedAddress(selectedAddress);
                            }}
                            disabled={!lookupAddresses.length}
                        />
                        <InputCustom
                            newLabel="Alternate Number"
                            placeholder="Alternate Number"
                            value={getValue('land_line_number')}
                            onChange={(e) => update({'land_line_number': e.target.value})}
                        />
                        <InputCustom
                            newLabel="City"
                            placeholder="City"
                            value={getValue('city')}
                            onChange={(e) => update({'city': e.target.value})}
                        />
                        <InputKeySelect
                            newLabel="Time at Address"
                            options={constants.timeAtAddressType}
                            value={getValue('time_at_address')}
                            onChange={(e) => update({'time_at_address': e.target.value})}
                            defaultOption
                            invalid={!!errors?.time_at_address}
                            errorMessage={errors?.time_at_address}
                        />
                    </Col>

                    <Col md={4} sm={6}>
                        <FormGroup className="d-flex align-items-center">
                            <label className="form-control-label w-50" htmlFor="detail_is_active">
                                Is active
                            </label>
                            <Row>
                                <Col>
                                    <label className="custom-toggle">
                                        <input
                                            type="checkbox"
                                            checked={getValue('is_active') === 1}
                                            onChange={() =>
                                                update({'is_active': getValue('is_active') === 1 ? 0 : 1})
                                            }
                                        />
                                        <span
                                            className="custom-toggle-slider rounded-circle"
                                            data-label-off="No"
                                            data-label-on="Yes"
                                        />
                                    </label>
                                </Col>
                            </Row>
                        </FormGroup>

                        <InputCustom
                            newLabel="Building"
                            placeholder="Building"
                            value={getValue('building')}
                            onChange={(e) => update({'building': e.target.value})}
                        />

                        <ArraySelect
                            label="Country"
                            options={counties}
                            value={getValue('county_id')}
                            onChange={(e) => update({'county_id': e.target.value})}
                            invalid={!!errors?.county_id}
                            defaultOption
                            valueKey="id"
                            labelKey="name"
                            errorMessage="Please provide a county."
                        />
                    </Col>
                </Row>
                <div className="d-flex flex-row justify-content-end">
                    <ButtonContainer onClick={() => goList(true)}>Cancel</ButtonContainer>
                    <ButtonContainer reverse onClick={() => handleSave()}>Save</ButtonContainer>
                </div>

            </CardBody>
        </Card>
    );
}